import React from 'react';

const ProgressBar = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;
  const progressText = currentStep === 4 ? 'Cancellation complete' : `Step ${currentStep} of ${totalSteps}`;
  const bgColor = currentStep === 4 ? '#04DD0B' : '#60737C';
  return (
    currentStep ?
      <div className="progress-bar">
        <div className="progress-bar--filler" style={{ width: `${progress}%`, background: bgColor }} />
        <div className="progress-bar--text">{progressText}</div>
      </div>
      : null
  );
};

export default ProgressBar;
